"use client";

import React from "react";
import Service from "./Service";
import dashboard from "../../../constants/dashboard";
import { useNavigate } from "react-router-dom";
import { get_services } from "../../../service/api/service";
import { useAppDispatch, useAppSelector } from "../../../store";
import { IconChevronRight } from "@tabler/icons-react";
import Button from "../../../components/elements/form/Button";

const RegisteredUser = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const page = useAppSelector(({ service }) => service.current_page);
  const services = useAppSelector(({ service }) =>
    service.services?.slice(0, 8),
  );

  const onLoad = React.useCallback(() => {
    get_services(dispatch, page);
  }, [dispatch, page]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="flex flex-col gap-6 overflow-hidden">
      {/* Dashboard Cards Section */}
      <section className="bg-primary-500 rounded-2xl shadow-lg p-4 md:p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          {dashboard.dasboard.map((item) => (
            <button
              key={item.key}
              onClick={() => navigate(item.link)}
              className="flex items-center gap-4 bg-white p-4 rounded-xl hover:bg-primary-100 hover:text-white transition-all duration-300 group shadow-sm hover:shadow-md"
            >
              <div className="flex-shrink-0 p-2 bg-primary-50 rounded-full">
                <img
                  alt={item.label}
                  src={item.icon}
                  className="w-10 h-10 object-contain transition-transform group-hover:scale-110"
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-primary-700 font-bold text-sm md:text-base truncate group-hover:text-white transition-colors">
                  {item.label}
                </p>
              </div>
              <IconChevronRight className="w-4 h-4 text-primary-300 group-hover:text-white transition-colors" />
            </button>
          ))}
        </div>
      </section>

      {/* Quick Links Section */}
      <section>
        <div className="flex overflow-x-auto pb-2 scrollbar-thin scrollbar-thumb-primary-200 scrollbar-track-transparent">
          <div className="flex gap-3 px-1">
            {dashboard.links.map((item, index) => (
              <Button
                title={item.name}
                key={index}
                onHandler={() => navigate(item.link)}
                className="flex items-center whitespace-nowrap px-5 py-2.5 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors duration-300"
              />
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="flex-1 overflow-hidden pb-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-gray-800">
            Available Services
          </h2>
          <Button
            title="View all services"
            onHandler={() => navigate("/services")}
            className="text-md text-primary-500 hover:text-primary-700 flex items-center gap-1 transition-colors"
            rightIcon={<IconChevronRight className="w-4 h-4" />}
          />
        </div>

        {/* Converted to responsive grid */}
        <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {services?.length > 0 ? (
              services.map((item) => (
                <Service
                  key={item.id}
                  item={item}
                  className="h-full transition-transform hover:translate-y-[-5px]"
                />
              ))
            ) : (
              <div className="col-span-full py-12 flex items-center justify-center">
                <p className="text-gray-500">No services available</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default RegisteredUser;
